<template>
  <div>   
    <header class="bg-color border-b border-slate-200">
      <div class="container flex items-center justify-between py-4">
        <router-link to="/" class="flex items-center gap-2">
          <img 
            src="@/assets/public/logo_odos_4.png" 
            alt="Logo" 
            class="h-10 w-auto sm:h-12 md:h-14 lg:h-16 transition-all duration-300"
          />
        </router-link>
        
        <nav class="flex items-center gap-4">
          <router-link v-if="ready && isAdmin" class="navlink" to="/admin/dashboard">รายชื่อ</router-link>
          <router-link v-if="ready && isSuperAdmin" class="navlink" to="/admin/users">ตั้งค่า admin</router-link>
        </nav>
      </div>
    </header>
    <main class="container py-8">
      <router-view :key="$route.fullPath" />
    </main>
    <!-- <main class="container py-8">
      <router-view></router-view>
    </main> -->
    <footer class="container py-8 text-center text-xs text-slate-500">
      Copyright © BY depa
    </footer>
  </div>

</template>
<script setup>

import { useAuth } from './stores/auth'
import { ref, computed, onMounted } from 'vue'

const auth = useAuth()
const ready = ref(false)
const isAdmin = computed(() => auth.user?.role === 'admin' || auth.user?.role === 'superadmin')
const isSuperAdmin = computed(() => auth.user?.role === 'superadmin')               
// const isAdmin = computed(() => auth.user?.role === 'admin')


onMounted(async () => {
  if (!auth.user) await auth.check()
  ready.value = true
})

</script>

<style>
@font-face {
  font-family: 'LINESeed';
  src: url('@/assets/fonts/LINESeedSansTH_A_Rg.ttf') format('truetype');
  font-weight: 400;
  font-style: normal;
}

@font-face {
  font-family: 'LINESeed';
  src: url('@/assets/fonts/LINESeedSansTH_A_Bd.ttf') format('truetype');
  font-weight: 700;
  font-style: normal;
}

:root, body {
  font-family: 'LINESeed';
}

.bg-color {
  background-color: #FFF200; 
}

header {
  height: 60px;
  display: flex;
  align-items: center;
  padding: 0 16px;
}
</style>
